import { Link } from "@/lib/router-compat";
import { ChevronRight, Home } from "lucide-react";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

const Breadcrumbs = ({ items }: { items: BreadcrumbItem[] }) => (
  <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-sm text-primary-foreground/85 py-3">
    <Link to="/" className="hover:text-primary-foreground transition-colors"><Home className="w-4 h-4" /></Link>
    {items.map((item, i) => (
      <span key={i} className="flex items-center gap-1">
        <ChevronRight className="w-3 h-3" />
        {item.href ? (
          <Link to={item.href} className="hover:text-primary-foreground transition-colors">{item.label}</Link>
        ) : (
          <span className="text-primary-foreground font-medium">{item.label}</span>
        )}
      </span>
    ))}
  </nav>
);

export default Breadcrumbs;
